import { Paper, Stack, SxProps, Theme, Typography } from '@mui/material';
import { useColumnResizer } from '../../layout/columnResizer/columnResizer';
import { ReactNode } from 'react';
import { Resizer } from '../../layout/columnResizer/resizer';

export interface TitledPaperProps {
  columnId?: string;
  initialColumnWidth?: number;
  title: string;
  icon?: JSX.Element;
  children: ReactNode;
  color?: string;
  sx?: SxProps<Theme> | undefined;
  resizeLeft?: boolean;
  resizeable?: boolean;
  elementTopRight?: JSX.Element;
}

/**
 * @summary Generic component containing a paper with a title and an optional icon
 * Note that top level children are divided using MUI Divider components
 * @param title - string shown at the top of the paper
 * @public
 */
export const TitledPaper = (props: TitledPaperProps) => {
  const {
    columnId,
    initialColumnWidth,
    title,
    icon,
    children,
    color,
    sx,
    resizeLeft = false,
    resizeable = true,
    elementTopRight
  } = props;

  const { columnWidth } = useColumnResizer(columnId, initialColumnWidth);
  return (
    <Stack direction="row" height="inherit">
      {resizeLeft && resizeable && <Resizer resizeColumnId={columnId} left={resizeLeft} />}
      <Paper
        elevation={0}
        square={true}
        sx={{
          ...sx,
          background: color,
          display: 'flex',
          flexDirection: 'column',
          width: columnWidth
        }}>
        <Stack direction={'row'} spacing={1} padding={1}>
          {icon}
          <Typography variant={'h3'} sx={{ marginRight: 'auto' }}>
            {title}
          </Typography>
          {elementTopRight}
        </Stack>
        {children}
      </Paper>
      {!resizeLeft && resizeable && <Resizer resizeColumnId={columnId} left={resizeLeft} />}
    </Stack>
  );
};
